// import { useEffect, useState } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { Button } from '@/components/ui/button';
// import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
// import { Badge } from '@/components/ui/badge';
// import { Progress } from '@/components/ui/progress';
// import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
// import { Input } from '@/components/ui/input';
// import { toast } from 'sonner';
// import { ArrowLeft, Mail, Phone, Briefcase, Calendar, Target, Award, TrendingUp, FileText, Loader2, Copy, CheckCircle, Trash2, Link as LinkIcon } from 'lucide-react';
// import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
// import api from '@/utils/api';

// export default function CandidateDetail({ user, onLogout }) {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [updatingStatus, setUpdatingStatus] = useState(false);
//   const [copied, setCopied] = useState(false);

//   useEffect(() => {
//     fetchCandidateDetails();
//   }, [id]);

//   const fetchCandidateDetails = async () => {
//     try {
//       const response = await api.get(`/candidates/${id}`);
//       setData(response.data);
//     } catch (error) {
//       toast.error('Erro ao carregar dados do candidato');
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleStatusChange = async (newStatus) => {
//     setUpdatingStatus(true);
//     try {
//       await api.patch(`/candidates/${id}/status`, { status: newStatus });
//       toast.success('Status atualizado com sucesso');
//       fetchCandidateDetails();
//     } catch (error) {
//       toast.error('Erro ao atualizar status');
//     } finally {
//       setUpdatingStatus(false);
//     }
//   };

//   const handleCopyLink = () => {
//     const inviteLink = `${window.location.origin}/avaliacao/${data.candidate.invite_token}`;
//     navigator.clipboard.writeText(inviteLink);
//     setCopied(true);
//     toast.success('Link copiado!');
//     setTimeout(() => setCopied(false), 2000);
//   };

//   const handleDeleteCandidate = async () => {
//     if (!window.confirm(`Tem certeza que deseja excluir ${data.candidate.full_name}? Esta ação não pode ser desfeita.`)) {
//       return;
//     }

//     try {
//       await api.delete(`/candidates/${id}`);
//       toast.success('Candidato excluído com sucesso');
//       navigate('/dashboard');
//     } catch (error) {
//       toast.error('Erro ao excluir candidato');
//       console.error(error);
//     }
//   };

//   const handleDownloadPDF = async () => {
//     try {
//       toast.info('Gerando relatório PDF...');
//       const response = await api.get(`/results/${id}/pdf`, {
//         responseType: 'blob'
//       });
      
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement('a');
//       link.href = url;
//       link.setAttribute('download', `relatorio_disc_${data.candidate.full_name.replace(/\s+/g, '_')}.pdf`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
      
//       toast.success('PDF baixado com sucesso!');
//     } catch (error) {
//       toast.error('Erro ao gerar PDF');
//       console.error(error);
//     }
//   };

//   const handleDownloadProfessionalPDF = async (reportType = 'completo') => {
//     try {
//       toast.info(`Gerando relatório profissional (${reportType})...`);
//       const response = await api.get(`/results/${id}/pdf-professional?report_type=${reportType}`, {
//         responseType: 'blob'
//       });
      
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement('a');
//       link.href = url;
//       link.setAttribute('download', `relatorio_disc_professional_${data.candidate.full_name.replace(/\s+/g, '_')}_${reportType}.pdf`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
      
//       toast.success('PDF profissional baixado com sucesso!');
//     } catch (error) {
//       toast.error('Erro ao gerar PDF profissional');
//       console.error(error);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-gray-50 to-slate-100">
//         <Loader2 className="w-12 h-12 animate-spin text-indigo-600" />
//       </div>
//     );
//   }

//   const { candidate, result } = data;

//   const radarData = result ? [
//     { factor: 'Dominância (D)', value: result.pct_d, fullMark: 100 },
//     { factor: 'Influência (I)', value: result.pct_i, fullMark: 100 },
//     { factor: 'Estabilidade (S)', value: result.pct_s, fullMark: 100 },
//     { factor: 'Conformidade (C)', value: result.pct_c, fullMark: 100 }
//   ] : [];

//   const barData = result ? [
//     { name: 'D', value: result.pct_d, label: 'Líder' },
//     { name: 'I', value: result.pct_i, label: 'Comunicador' },
//     { name: 'S', value: result.pct_s, label: 'Executor' },
//     { name: 'C', value: result.pct_c, label: 'Planejador' }
//   ] : [];

//   const compatibilityData = result ? [
//     { area: 'Suporte N1', score: result.compatibility.support_n1 },
//     { area: 'Qualidade', score: result.compatibility.quality },
//     { area: 'SDR/Atendimento', score: result.compatibility.sdr },
//     { area: 'Projetos/Infra', score: result.compatibility.projects }
//   ] : [];

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-slate-50 via-gray-50 to-slate-100">
//       {/* Header */}
//       <header className="glass border-b sticky top-0 z-10 shadow-sm">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
//           <div className="flex items-center justify-between">
//             <Button variant="ghost" onClick={() => navigate('/dashboard')} data-testid="back-button">
//               <ArrowLeft className="w-4 h-4 mr-2" />
//               Voltar
//             </Button>
//             <div className="text-right">
//               <p className="text-sm text-gray-600">{user?.name}</p>
//             </div>
//           </div>
//         </div>
//       </header>

//       <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//         {/* Candidate Info Card */}
//         <Card className="shadow-premium border-0 glass mb-8" data-testid="candidate-info-card">
//           <CardHeader>
//             <div className="flex items-start justify-between">
//               <div className="flex-1">
//                 <CardTitle className="text-3xl mb-2" style={{fontFamily: 'Manrope'}}>{candidate.full_name}</CardTitle>
//                 <div className="flex flex-wrap items-center gap-4 mt-3">
//                   <div className="flex items-center text-gray-600">
//                     <Mail className="w-4 h-4 mr-2" />
//                     <span className="text-sm">{candidate.email}</span>
//                   </div>
//                   {candidate.phone && (
//                     <div className="flex items-center text-gray-600">
//                       <Phone className="w-4 h-4 mr-2" />
//                       <span className="text-sm">{candidate.phone}</span>
//                     </div>
//                   )}
//                   {candidate.position && (
//                     <div className="flex items-center text-gray-600">
//                       <Briefcase className="w-4 h-4 mr-2" />
//                       <span className="text-sm">{candidate.position}</span>
//                     </div>
//                   )}
//                   <div className="flex items-center text-gray-600">
//                     <Calendar className="w-4 h-4 mr-2" />
//                     <span className="text-sm">{new Date(candidate.created_at).toLocaleDateString('pt-BR')}</span>
//                   </div>
//                 </div>
//               </div>
//               <div className="flex flex-col gap-3">
//                 <Select value={candidate.status} onValueChange={handleStatusChange} disabled={updatingStatus}>
//                   <SelectTrigger className="w-48" data-testid="status-select">
//                     <SelectValue />
//                   </SelectTrigger>
//                   <SelectContent>
//                     <SelectItem value="INVITED">Convidado</SelectItem>
//                     <SelectItem value="IN_PROGRESS">Em Andamento</SelectItem>
//                     <SelectItem value="COMPLETED">Concluído</SelectItem>
//                     <SelectItem value="APPROVED_INTERVIEW">Aprovado p/ Entrevista</SelectItem>
//                     <SelectItem value="REJECTED">Reprovado</SelectItem>
//                   </SelectContent>
//                 </Select>
                
//                 {(user?.role === 'ADMIN' || user?.role === 'HR') && (candidate.status === 'REJECTED' || candidate.status === 'INVITED') && (
//                   <Button
//                     variant="outline"
//                     onClick={handleDeleteCandidate}
//                     className="text-red-600 hover:text-red-700 hover:bg-red-50 border-red-300"
//                     data-testid="delete-candidate-button"
//                   >
//                     <Trash2 className="w-4 h-4 mr-2" />
//                     Excluir Candidato
//                   </Button>
//                 )}
//               </div>
//             </div>
//           </CardHeader>
//         </Card>

//         {/* Link de Convite Card */}
//         <Card className="shadow-premium border-0 glass mb-8">
//           <CardHeader>
//             <CardTitle className="text-lg flex items-center">
//               <LinkIcon className="w-5 h-5 mr-2 text-indigo-600" />
//               Link de Convite para Avaliação
//             </CardTitle>
//           </CardHeader>
//           <CardContent>
//             <div className="space-y-4">
//               <div className="flex gap-2">
//                 <Input
//                   value={`${window.location.origin}/avaliacao/${candidate.invite_token}`}
//                   readOnly
//                   className="font-mono text-sm"
//                   data-testid="candidate-invite-link"
//                 />
//                 <Button
//                   onClick={handleCopyLink}
//                   variant={copied ? "default" : "outline"}
//                   className="flex-shrink-0"
//                   data-testid="copy-invite-link-button"
//                 >
//                   {copied ? (
//                     <>
//                       <CheckCircle className="w-4 h-4 mr-2" />
//                       Copiado!
//                     </>
//                   ) : (
//                     <>
//                       <Copy className="w-4 h-4 mr-2" />
//                       Copiar Link
//                     </>
//                   )}
//                 </Button>
//               </div>
              
//               <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
//                 <p className="text-sm text-blue-800">
//                   <strong>📧 Como usar:</strong> Copie o link acima e envie para o candidato por email, WhatsApp ou outra mensagem. 
//                   O link expira em <strong>7 dias</strong> e o status será atualizado automaticamente quando o candidato iniciar.
//                 </p>
//               </div>
              
//               {candidate.status === 'INVITED' && (
//                 <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
//                   <p className="text-sm text-amber-900">
//                     ⏳ <strong>Aguardando:</strong> Este candidato ainda não iniciou a avaliação.
//                   </p>
//                 </div>
//               )}
//             </div>
//           </CardContent>
//         </Card>

//         {result ? (
//           <>
//             {/* Download PDF Button */}
//             <div className="flex justify-end mb-6">
//               <Button
//                 onClick={handleDownloadPDF}
//                 className="bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white"
//                 size="lg"
//                 data-testid="download-pdf-button"
//               >
//                 <FileText className="w-5 h-5 mr-2" />
//                 Baixar Relatório PDF Simples
//               </Button>
              
//               <Button
//                 onClick={() => handleDownloadProfessionalPDF('completo')}
//                 className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white"
//                 size="lg"
//                 data-testid="download-pdf-pro-complete-button"
//               >
//                 <Award className="w-5 h-5 mr-2" />
//                 PDF Profissional Completo
//               </Button>
              
//               <Button
//                 onClick={() => handleDownloadProfessionalPDF('intermediario')}
//                 className="bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white"
//                 size="lg"
//                 data-testid="download-pdf-pro-intermediate-button"
//               >
//                 <FileText className="w-5 h-5 mr-2" />
//                 PDF Profissional Intermediário
//               </Button>
//             </div>

//             {/* DISC Profile Summary */}
//             <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
//               <Card className="shadow-hover border-0 glass">
//                 <CardHeader>
//                   <CardTitle className="text-lg flex items-center">
//                     <Target className="w-5 h-5 mr-2 text-indigo-600" />
//                     Perfil Dominante
//                   </CardTitle>
//                 </CardHeader>
//                 <CardContent>
//                   <div className="text-center">
//                     <p className="text-4xl font-bold text-indigo-600 mb-2">{result.dominant}</p>
//                     <Badge className="text-lg px-4 py-1">{result.modern_label}</Badge>
//                   </div>
//                 </CardContent>
//               </Card>

//               <Card className="shadow-hover border-0 glass">
//                 <CardHeader>
//                   <CardTitle className="text-lg flex items-center">
//                     <TrendingUp className="w-5 h-5 mr-2 text-green-600" />
//                     Melhor Compatibilidade
//                   </CardTitle>
//                 </CardHeader>
//                 <CardContent>
//                   <div className="space-y-2">
//                     {compatibilityData.sort((a, b) => b.score - a.score)[0] && (
//                       <>
//                         <p className="text-2xl font-bold text-gray-900">
//                           {compatibilityData.sort((a, b) => b.score - a.score)[0].area}
//                         </p>
//                         <p className="text-3xl font-bold text-green-600">
//                           {compatibilityData.sort((a, b) => b.score - a.score)[0].score.toFixed(1)}%
//                         </p>
//                       </>
//                     )}
//                   </div>
//                 </CardContent>
//               </Card>

//               <Card className="shadow-hover border-0 glass">
//                 <CardHeader>
//                   <CardTitle className="text-lg flex items-center">
//                     <Award className="w-5 h-5 mr-2 text-amber-600" />
//                     Pontuação Geral
//                   </CardTitle>
//                 </CardHeader>
//                 <CardContent>
//                   <div className="space-y-2">
//                     <p className="text-sm text-gray-600">Média de compatibilidade</p>
//                     <p className="text-3xl font-bold text-amber-600">
//                       {(compatibilityData.reduce((acc, d) => acc + d.score, 0) / compatibilityData.length).toFixed(1)}%
//                     </p>
//                   </div>
//                 </CardContent>
//               </Card>
//             </div>

//             {/* Charts */}
//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
//               {/* Radar Chart */}
//               <Card className="shadow-premium border-0 glass">
//                 <CardHeader>
//                   <CardTitle>Perfil DISC - Visão Geral</CardTitle>
//                 </CardHeader>
//                 <CardContent>
//                   <ResponsiveContainer width="100%" height={300}>
//                     <RadarChart data={radarData}>
//                       <PolarGrid />
//                       <PolarAngleAxis dataKey="factor" tick={{ fontSize: 12 }} />
//                       <PolarRadiusAxis domain={[0, 100]} />
//                       <Radar name="Pontuação" dataKey="value" stroke="#6366f1" fill="#6366f1" fillOpacity={0.6} />
//                     </RadarChart>
//                   </ResponsiveContainer>
//                 </CardContent>
//               </Card>

//               {/* Bar Chart */}
//               <Card className="shadow-premium border-0 glass">
//                 <CardHeader>
//                   <CardTitle>Distribuição por Fator</CardTitle>
//                 </CardHeader>
//                 <CardContent>
//                   <ResponsiveContainer width="100%" height={300}>
//                     <BarChart data={barData}>
//                       <CartesianGrid strokeDasharray="3 3" />
//                       <XAxis dataKey="name" />
//                       <YAxis domain={[0, 100]} />
//                       <Tooltip />
//                       <Bar dataKey="value" fill="#6366f1" />
//                     </BarChart>
//                   </ResponsiveContainer>
//                   <div className="mt-4 grid grid-cols-2 gap-2 text-xs text-gray-600">
//                     {barData.map((item, idx) => (
//                       <div key={idx}>{item.name} = {item.label}</div>
//                     ))}
//                   </div>
//                 </CardContent>
//               </Card>
//             </div>

//             {/* Compatibility Scores */}
//             <Card className="shadow-premium border-0 glass mb-8">
//               <CardHeader>
//                 <CardTitle>Compatibilidade por Área</CardTitle>
//               </CardHeader>
//               <CardContent>
//                 <div className="space-y-4">
//                   {compatibilityData.sort((a, b) => b.score - a.score).map((item, idx) => (
//                     <div key={idx}>
//                       <div className="flex items-center justify-between mb-2">
//                         <span className="font-medium text-gray-900">{item.area}</span>
//                         <span className="font-bold text-indigo-600">{item.score.toFixed(1)}%</span>
//                       </div>
//                       <Progress value={item.score} className="h-3" />
//                     </div>
//                   ))}
//                 </div>
//               </CardContent>
//             </Card>

//             {/* Scores Details */}
//             <Card className="shadow-premium border-0 glass">
//               <CardHeader>
//                 <CardTitle>Detalhamento DISC</CardTitle>
//               </CardHeader>
//               <CardContent>
//                 <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
//                   <div>
//                     <p className="text-sm font-medium text-gray-600 mb-2">Dominância (D)</p>
//                     <p className="text-3xl font-bold text-red-600">{result.pct_d.toFixed(1)}%</p>
//                     <p className="text-xs text-gray-500 mt-1">Pontuação: {result.score_d}/20</p>
//                   </div>
//                   <div>
//                     <p className="text-sm font-medium text-gray-600 mb-2">Influência (I)</p>
//                     <p className="text-3xl font-bold text-yellow-600">{result.pct_i.toFixed(1)}%</p>
//                     <p className="text-xs text-gray-500 mt-1">Pontuação: {result.score_i}/20</p>
//                   </div>
//                   <div>
//                     <p className="text-sm font-medium text-gray-600 mb-2">Estabilidade (S)</p>
//                     <p className="text-3xl font-bold text-green-600">{result.pct_s.toFixed(1)}%</p>
//                     <p className="text-xs text-gray-500 mt-1">Pontuação: {result.score_s}/20</p>
//                   </div>
//                   <div>
//                     <p className="text-sm font-medium text-gray-600 mb-2">Conformidade (C)</p>
//                     <p className="text-3xl font-bold text-blue-600">{result.pct_c.toFixed(1)}%</p>
//                     <p className="text-xs text-gray-500 mt-1">Pontuação: {result.score_c}/20</p>
//                   </div>
//                 </div>
//               </CardContent>
//             </Card>
//           </>
//         ) : (
//           <Card className="shadow-premium border-0 glass">
//             <CardContent className="py-12 text-center">
//               <FileText className="w-16 h-16 text-gray-300 mx-auto mb-4" />
//               <p className="text-gray-600 text-lg mb-2">Avaliação ainda não concluída</p>
//               <p className="text-gray-500 text-sm">
//                 O candidato precisa completar a avaliação DISC para visualizar os resultados.
//               </p>
//             </CardContent>
//           </Card>
//         )}
//       </main>
//     </div>
//   );
// }













import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Progress } from '@/components/ui/progress';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { ArrowLeft, Mail, Phone, Briefcase, Calendar, Target, Award, TrendingUp, FileText, Loader2, Copy, CheckCircle, Trash2, Link as LinkIcon, RefreshCw, ClipboardList } from 'lucide-react';
import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import api from '@/utils/api';

export default function CandidateDetail({ user, onLogout }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updatingStatus, setUpdatingStatus] = useState(false);
  const [copied, setCopied] = useState(false);
  const [renewingLink, setRenewingLink] = useState(false);
  const [assessments, setAssessments] = useState([]);
  const [updatingAssessment, setUpdatingAssessment] = useState(false);

  // --- INÍCIO DA CORREÇÃO ---
  // Novos estados para carregar os setores e suas compatibilidades
  const [sectors, setSectors] = useState([]);
  const [sectorCompatibility, setSectorCompatibility] = useState(null);
  const [loadingSectors, setLoadingSectors] = useState(true);
  // --- FIM DA CORREÇÃO ---

  useEffect(() => {
    fetchCandidateDetails();
  }, [id]);

  const fetchCandidateDetails = async () => {
    try {
      const response = await api.get(`/candidates/${id}`);
      setData(response.data);
    } catch (error) {
      toast.error('Erro ao carregar dados do candidato');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // --- INÍCIO DA CORREÇÃO ---
  // 1. Busca todos os setores cadastrados
  useEffect(() => {
    const fetchSectors = async () => {
      try {
        const response = await api.get('/sectors');
        setSectors(response.data);
      } catch (error) {
        toast.error('Erro ao carregar lista de setores');
      }
    };
    fetchSectors();
  }, []); // Executa uma vez

  useEffect(() => {
    const fetchAssessments = async () => {
      try {
        const response = await api.get('/assessments');
        setAssessments(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchAssessments();
  }, []);

  // 2. Quando tiver o candidato E os setores, calcula a compatibilidade para CADA setor
  useEffect(() => {
    // Só executa se já tivermos o resultado do candidato e a lista de setores
    if (data && data.result && sectors.length > 0) {
      
      const fetchAllCompatibilities = async () => {
        setLoadingSectors(true);
        try {
          // Cria um array de chamadas de API (uma para cada setor)
          const promises = sectors.map(sector => 
            api.get(`/sectors/${sector.id}/compatibility/${id}`)
          );
          
          // Espera todas as chamadas terminarem
          const responses = await Promise.all(promises);
          
          // Formata os dados para o gráfico
          const compatScores = responses.map(res => ({
            area: res.data.sector_name,
            score: res.data.compatibility_score
          }));
          
          setSectorCompatibility(compatScores);

        } catch (error) {
          toast.error('Erro ao calcular compatibilidade com setores');
          console.error(error);
        } finally {
          setLoadingSectors(false);
        }
      };
      
      fetchAllCompatibilities();
    }
  }, [data, sectors, id]); // Dependências
  // --- FIM DA CORREÇÃO ---


  const handleStatusChange = async (newStatus) => {
    setUpdatingStatus(true);
    try {
      await api.patch(`/candidates/${id}/status`, { status: newStatus });
      toast.success('Status atualizado com sucesso');
      fetchCandidateDetails();
    } catch (error) {
      toast.error('Erro ao atualizar status');
    } finally {
      setUpdatingStatus(false);
    }
  };

  const handleCopyLink = () => {
    const inviteLink = `${window.location.origin}/avaliacao/${data.candidate.invite_token}`;
    navigator.clipboard.writeText(inviteLink);
    setCopied(true);
    toast.success('Link copiado!');
    setTimeout(() => setCopied(false), 2000);
  };

  const handleRenewLink = async () => {
    setRenewingLink(true);
    try {
      await api.post(`/candidates/${id}/renew-link`);
      toast.success('Link renovado! Novo prazo de 7 dias.');
      fetchCandidateDetails();
    } catch (error) {
      toast.error('Erro ao renovar link');
      console.error(error);
    } finally {
      setRenewingLink(false);
    }
  };

  const handleAssessmentChange = async (assessmentId) => {
    setUpdatingAssessment(true);
    try {
      await api.patch(`/candidates/${id}/assessment`, {
        assessment_id: assessmentId === 'none' ? '' : assessmentId
      });
      toast.success('Avaliação do candidato atualizada');
      fetchCandidateDetails();
    } catch (error) {
      toast.error('Erro ao atualizar avaliação');
      console.error(error);
    } finally {
      setUpdatingAssessment(false);
    }
  };

  const handleDeleteCandidate = async () => {
    if (!window.confirm(`Tem certeza que deseja excluir ${data.candidate.full_name}? Esta ação não pode ser desfeita.`)) {
      return;
    }

    try {
      await api.delete(`/candidates/${id}`);
      toast.success('Candidato excluído com sucesso');
      navigate('/dashboard');
    } catch (error) {
      toast.error('Erro ao excluir candidato');
      console.error(error);
    }
  };

  const handleDownloadPDF = async () => {
    try {
      toast.info('Gerando relatório PDF...');
      const response = await api.get(`/results/${id}/pdf`, {
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `relatorio_disc_${data.candidate.full_name.replace(/\s+/g, '_')}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      toast.success('PDF baixado com sucesso!');
    } catch (error) {
      toast.error('Erro ao gerar PDF');
      console.error(error);
    }
  };

  const handleDownloadProfessionalPDF = async (reportType = 'completo') => {
    try {
      toast.info(`Gerando relatório profissional (${reportType})...`);
      const response = await api.get(`/results/${id}/pdf-professional?report_type=${reportType}`, {
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `relatorio_disc_professional_${data.candidate.full_name.replace(/\s+/g, '_')}_${reportType}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      toast.success('PDF profissional baixado com sucesso!');
    } catch (error) {
      toast.error('Erro ao gerar PDF profissional');
      console.error(error);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-gray-50 to-slate-100">
        <Loader2 className="w-12 h-12 animate-spin text-indigo-600" />
      </div>
    );
  }

  const { candidate, result } = data;

  const radarData = result ? [
    { factor: 'Dominância (D)', value: result.pct_d, fullMark: 100 },
    { factor: 'Influência (I)', value: result.pct_i, fullMark: 100 },
    { factor: 'Estabilidade (S)', value: result.pct_s, fullMark: 100 },
    { factor: 'Conformidade (C)', value: result.pct_c, fullMark: 100 }
  ] : [];

  const barData = result ? [
    { name: 'D', value: result.pct_d, label: 'Líder' },
    { name: 'I', value: result.pct_i, label: 'Comunicador' },
    { name: 'S', value: result.pct_s, label: 'Executor' },
    { name: 'C', value: result.pct_c, label: 'Planejador' }
  ] : [];

  // --- CORREÇÃO ---
  // A variável 'compatibilityData' foi removida.
  // Usaremos 'sectorCompatibility' (o novo estado) diretamente no JSX.

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-gray-50 to-slate-100">
      {/* Header */}
      <header className="glass border-b sticky top-0 z-10 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <Button variant="ghost" onClick={() => navigate('/dashboard')} data-testid="back-button">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Voltar
            </Button>
            <div className="text-right">
              <p className="text-sm text-gray-600">{user?.name}</p>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Candidate Info Card */}
        <Card className="shadow-premium border-0 glass mb-8" data-testid="candidate-info-card">
          <CardHeader>
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <CardTitle className="text-3xl mb-2" style={{fontFamily: 'Manrope'}}>{candidate.full_name}</CardTitle>
                <div className="flex flex-wrap items-center gap-4 mt-3">
                  <div className="flex items-center text-gray-600">
                    <Mail className="w-4 h-4 mr-2" />
                    <span className="text-sm">{candidate.email}</span>
                  </div>
                  {candidate.phone && (
                    <div className="flex items-center text-gray-600">
                      <Phone className="w-4 h-4 mr-2" />
                      <span className="text-sm">{candidate.phone}</span>
                    </div>
                  )}
                  {candidate.position && (
                    <div className="flex items-center text-gray-600">
                      <Briefcase className="w-4 h-4 mr-2" />
                      <span className="text-sm">{candidate.position}</span>
                    </div>
                  )}
                  <div className="flex items-center text-gray-600">
                    <Calendar className="w-4 h-4 mr-2" />
                    <span className="text-sm">{new Date(candidate.created_at).toLocaleDateString('pt-BR')}</span>
                  </div>
                </div>
              </div>
              <div className="flex flex-col gap-3">
                <Select value={candidate.status} onValueChange={handleStatusChange} disabled={updatingStatus}>
                  <SelectTrigger className="w-48" data-testid="status-select">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="INVITED">Convidado</SelectItem>
                    <SelectItem value="IN_PROGRESS">Em Andamento</SelectItem>
                    <SelectItem value="COMPLETED">Concluído</SelectItem>
                    <SelectItem value="APPROVED_INTERVIEW">Aprovado p/ Entrevista</SelectItem>
                    <SelectItem value="REJECTED">Reprovado</SelectItem>
                  </SelectContent>
                </Select>
                
                {(user?.role === 'ADMIN' || user?.role === 'HR') && (candidate.status === 'REJECTED' || candidate.status === 'INVITED') && (
                  <Button
                    variant="outline"
                    onClick={handleDeleteCandidate}
                    className="text-red-600 hover:text-red-700 hover:bg-red-50 border-red-300"
                    data-testid="delete-candidate-button"
                  >
                    <Trash2 className="w-4 h-4 mr-2" />
                    Excluir Candidato
                  </Button>
                )}
              </div>
            </div>
          </CardHeader>
        </Card>

        {/* Link de Convite Card */}
        <Card className="shadow-premium border-0 glass mb-8">
          <CardHeader>
            <CardTitle className="text-lg flex items-center">
              <LinkIcon className="w-5 h-5 mr-2 text-indigo-600" />
              Link de Convite para Avaliação
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div className="flex gap-2">
                <Input
                  value={`${window.location.origin}/avaliacao/${candidate.invite_token}`}
                  readOnly
                  className="font-mono text-sm"
                  data-testid="candidate-invite-link"
                />
                <Button
                  onClick={handleCopyLink}
                  variant={copied ? "default" : "outline"}
                  className="flex-shrink-0"
                  data-testid="copy-invite-link-button"
                >
                  {copied ? (
                    <>
                      <CheckCircle className="w-4 h-4 mr-2" />
                      Copiado!
                    </>
                  ) : (
                    <>
                      <Copy className="w-4 h-4 mr-2" />
                      Copiar Link
                    </>
                  )}
                </Button>
                <Button
                  onClick={handleRenewLink}
                  variant="outline"
                  className="flex-shrink-0"
                  disabled={renewingLink}
                  data-testid="renew-invite-link-button"
                >
                  <RefreshCw className={`w-4 h-4 mr-2 ${renewingLink ? 'animate-spin' : ''}`} />
                  Renovar Link
                </Button>
              </div>

              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <p className="text-sm text-blue-800">
                  <strong>📧 Como usar:</strong> Copie o link acima e envie para o candidato por email, WhatsApp ou outra mensagem.
                  O link expira em <strong>7 dias</strong> e o status será atualizado automaticamente quando o candidato iniciar. Se o link expirar, use <strong>Renovar Link</strong> para gerar um novo prazo de 7 dias sem perder o histórico do candidato.
                </p>
              </div>

              <div className="space-y-2">
                <Label className="text-sm font-semibold text-gray-700 flex items-center">
                  <ClipboardList className="w-4 h-4 mr-2 text-indigo-600" />
                  Avaliação (questões) usada por este candidato
                </Label>
                <Select
                  value={candidate.assessment_id || 'none'}
                  onValueChange={handleAssessmentChange}
                  disabled={updatingAssessment}
                >
                  <SelectTrigger className="w-full" data-testid="candidate-assessment-select">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="none">Padrão (20 perguntas)</SelectItem>
                    {assessments.map((assessment) => (
                      <SelectItem key={assessment.id} value={assessment.id}>
                        {assessment.name}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              {candidate.status === 'INVITED' && (
                <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                  <p className="text-sm text-amber-900">
                    ⏳ <strong>Aguardando:</strong> Este candidato ainda não iniciou a avaliação.
                  </p>
                </div>
              )}
            </div>
          </CardContent>
        </Card>

        {result ? (
          <>
            {/* Download PDF Button */}
            <div className="flex justify-end mb-6">
              <Button
                onClick={handleDownloadPDF}
                className="bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white"
                size="lg"
                data-testid="download-pdf-button"
              >
                <FileText className="w-5 h-5 mr-2" />
                Baixar Relatório PDF Simples
              </Button>
              
              <Button
                onClick={() => handleDownloadProfessionalPDF('completo')}
                className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white"
                size="lg"
                data-testid="download-pdf-pro-complete-button"
              >
                <Award className="w-5 h-5 mr-2" />
                PDF Profissional Completo
              </Button>
              
              <Button
                onClick={() => handleDownloadProfessionalPDF('intermediario')}
                className="bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white"
                size="lg"
                data-testid="download-pdf-pro-intermediate-button"
              >
                <FileText className="w-5 h-5 mr-2" />
                PDF Profissional Intermediário
              </Button>
            </div>

            {/* DISC Profile Summary */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
              <Card className="shadow-hover border-0 glass">
                <CardHeader>
                  <CardTitle className="text-lg flex items-center">
                    <Target className="w-5 h-5 mr-2 text-indigo-600" />
                    Perfil Dominante
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="text-center">
                    <p className="text-4xl font-bold text-indigo-600 mb-2">{result.dominant}</p>
                    <Badge className="text-lg px-4 py-1">{result.modern_label}</Badge>
                  </div>
                </CardContent>
              </Card>

              {/* --- INÍCIO DA CORREÇÃO --- */}
              {/* Card "Melhor Compatibilidade" agora usa 'sectorCompatibility' */}
              <Card className="shadow-hover border-0 glass">
                <CardHeader>
                  <CardTitle className="text-lg flex items-center">
                    <TrendingUp className="w-5 h-5 mr-2 text-green-600" />
                    Melhor Compatibilidade (Setor)
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  {loadingSectors && (
                    <p className="text-sm text-gray-500">Calculando...</p>
                  )}
                  {!loadingSectors && sectorCompatibility && sectorCompatibility.length > 0 && (
                    <div className="space-y-2">
                      {(() => { // IIFE para ordenar e pegar o primeiro
                        const bestMatch = [...sectorCompatibility].sort((a, b) => b.score - a.score)[0];
                        return (
                          <>
                            <p className="text-2xl font-bold text-gray-900">
                              {bestMatch.area}
                            </p>
                            <p className="text-3xl font-bold text-green-600">
                              {bestMatch.score.toFixed(1)}%
                            </p>
                          </>
                        );
                      })()}
                    </div>
                  )}
                  {!loadingSectors && (!sectorCompatibility || sectorCompatibility.length === 0) && (
                    <p className="text-sm text-gray-500">Nenhum setor encontrado.</p>
                  )}
                </CardContent>
              </Card>

              {/* Card "Pontuação Geral" agora usa 'sectorCompatibility' */}
              <Card className="shadow-hover border-0 glass">
                <CardHeader>
                  <CardTitle className="text-lg flex items-center">
                    <Award className="w-5 h-5 mr-2 text-amber-600" />
                    Média (Todos Setores)
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  {loadingSectors && (
                    <p className="text-sm text-gray-500">Calculando...</p>
                  )}
                  {!loadingSectors && sectorCompatibility && sectorCompatibility.length > 0 && (
                    <div className="space-y-2">
                      <p className="text-sm text-gray-600">Média de compatibilidade</p>
                      <p className="text-3xl font-bold text-amber-600">
                        {(sectorCompatibility.reduce((acc, d) => acc + d.score, 0) / sectorCompatibility.length).toFixed(1)}%
                      </p>
                    </div>
                  )}
                  {!loadingSectors && (!sectorCompatibility || sectorCompatibility.length === 0) && (
                    <p className="text-sm text-gray-500">N/A</p>
                  )}
                </CardContent>
              </Card>
              {/* --- FIM DA CORREÇÃO --- */}
            </div>

            {/* Charts */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
              {/* Radar Chart */}
              <Card className="shadow-premium border-0 glass">
                <CardHeader>
                  <CardTitle>Perfil DISC - Visão Geral</CardTitle>
                </CardHeader>
                <CardContent>
                  <ResponsiveContainer width="100%" height={300}>
                    <RadarChart data={radarData}>
                      <PolarGrid />
                      <PolarAngleAxis dataKey="factor" tick={{ fontSize: 12 }} />
                      <PolarRadiusAxis domain={[0, 100]} />
                      <Radar name="Pontuação" dataKey="value" stroke="#6366f1" fill="#6366f1" fillOpacity={0.6} />
                    </RadarChart>
                  </ResponsiveContainer>
                </CardContent>
              </Card>

              {/* Bar Chart */}
              <Card className="shadow-premium border-0 glass">
                <CardHeader>
                  <CardTitle>Distribuição por Fator</CardTitle>
                </CardHeader>
                <CardContent>
                  <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={barData}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis domain={[0, 100]} />
                      <Tooltip />
                      <Bar dataKey="value" fill="#6366f1" />
                    </BarChart>
                  </ResponsiveContainer>
                  <div className="mt-4 grid grid-cols-2 gap-2 text-xs text-gray-600">
                    {barData.map((item, idx) => (
                      <div key={idx}>{item.name} = {item.label}</div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* --- INÍCIO DA CORREÇÃO --- */}
            {/* Card "Compatibilidade por Área" agora usa 'sectorCompatibility' */}
            <Card className="shadow-premium border-0 glass mb-8">
              <CardHeader>
                <CardTitle>Compatibilidade por Setor (Cadastrados)</CardTitle>
              </CardHeader>
              <CardContent>
                {loadingSectors && (
                  <div className="flex items-center justify-center h-24">
                    <Loader2 className="w-6 h-6 animate-spin text-indigo-600" />
                    <span className="ml-2 text-gray-600">Calculando compatibilidade...</span>
                  </div>
                )}
                {!loadingSectors && sectorCompatibility && (
                  <div className="space-y-4">
                    {[...sectorCompatibility].sort((a, b) => b.score - a.score).map((item, idx) => (
                      <div key={idx}>
                        <div className="flex items-center justify-between mb-2">
                          <span className="font-medium text-gray-900">{item.area}</span>
                          <span className="font-bold text-indigo-600">{item.score.toFixed(1)}%</span>
                        </div>
                        <Progress value={item.score} className="h-3" />
                      </div>
                    ))}
                  </div>
                )}
                {!loadingSectors && !sectorCompatibility && (
                  <p className="text-gray-500">Não foi possível carregar os dados de compatibilidade do setor.</p>
                )}
              </CardContent>
            </Card>
            {/* --- FIM DA CORREÇÃO --- */}

            {/* Scores Details */}
            <Card className="shadow-premium border-0 glass">
              <CardHeader>
                <CardTitle>Detalhamento DISC</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                  <div>
                    <p className="text-sm font-medium text-gray-600 mb-2">Dominância (D)</p>
                    <p className="text-3xl font-bold text-red-600">{result.pct_d.toFixed(1)}%</p>
                    <p className="text-xs text-gray-500 mt-1">Pontuação: {result.score_d}/20</p>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-600 mb-2">Influência (I)</p>
                    <p className="text-3xl font-bold text-yellow-600">{result.pct_i.toFixed(1)}%</p>
                    <p className="text-xs text-gray-500 mt-1">Pontuação: {result.score_i}/20</p>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-600 mb-2">Estabilidade (S)</p>
                    <p className="text-3xl font-bold text-green-600">{result.pct_s.toFixed(1)}%</p>
                    <p className="text-xs text-gray-500 mt-1">Pontuação: {result.score_s}/20</p>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-600 mb-2">Conformidade (C)</p>
                    <p className="text-3xl font-bold text-blue-600">{result.pct_c.toFixed(1)}%</p>
                    <p className="text-xs text-gray-500 mt-1">Pontuação: {result.score_c}/20</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </>
        ) : (
          <Card className="shadow-premium border-0 glass">
            <CardContent className="py-12 text-center">
              <FileText className="w-16 h-16 text-gray-300 mx-auto mb-4" />
              <p className="text-gray-600 text-lg mb-2">Avaliação ainda não concluída</p>
              <p className="text-gray-500 text-sm">
                O candidato precisa completar a avaliação DISC para visualizar os resultados.
              </p>
            </CardContent>
          </Card>
        )}
      </main>
    </div>
  );
}